import React from 'react';
import { Meteor } from 'meteor/meteor';
import Moment from 'react-moment';
import moment from 'moment';

import {
	Col,
	BPanel,
	Radio,
	FormGroup,
	FormControl,
	ControlLabel,
	Table,
	Modal,
	Button
} from '@sketchpixy/rubix';
var DatePicker = require("react-bootstrap-date-picker");

import { Flights } from '../../collections/flights/flights';
import { Montgolfieres } from '../../collections/montgolfieres/montgolfieres';
import { Users } from '../../collections/users/users';

import { scheduleReservation } from '../../collections/reservations/methods';
import { getAvailabilityCount } from '../../helpers/availabilities';


export class HistoryFlightComponent extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};
	}

	closeHistory() {
		this.setState({ showHistoryModal: false });
	}


	openHistory() {
		this.setState({ showHistoryModal: true });
	}

	getType(history) {

		if(history.type == "scheduled") {
			return "Programmée";
		}

		if(history.type == "cancelled") {
			return "Annulée";
		}

		if(history.type == "confirmed") {
			return "Confirmée";
		}

		if(history.type == "consumed") {
			return "Volée";
		}

	}

	getUser(id) {
		let user = Meteor.users.findOne(id);
		if(user) {
			return user.profile.firstName + ' ' + user.profile.lastName;
		} else {
			return '-';
		}
	}

	renderHistory() {
		return this.props.reservation.history.map((history) => (
			<tr>
				<td>{moment(history.date).format("DD/MM/YYYY")}</td>
				<td>{this.getType(history)}</td>
				<td>{moment(history.scheduledAt).format("DD/MM/YYYY")}</td>
				{history.userId &&
					<td>{this.getUser(history.userId)}</td>
				}
				{!history.userId &&
					<td>Client</td>
				}
			</tr>
		));
	}

	renderHistoryModal() {
		return (
			<Modal show={this.state.showHistoryModal} onHide={::this.closeHistory}>
				<Modal.Header closeButton>
					<Modal.Title>Historique la réservation n°{this.props.reservation.id}</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Table striped bordered condensed hover>
						<thead>
							<tr>
								<td>Le</td>
								<td>Action</td>
								<td>Date</td>
								<td>Par</td>
							</tr>
						</thead>
						<tbody>
							{this.renderHistory()}
						</tbody>
					</Table>
				</Modal.Body>
				<Modal.Footer>
					<Button onClick={::this.closeHistory}>Fermer</Button>
				</Modal.Footer>
			</Modal>
		);

	}

	render() {
		return (
			<div>
				<Button bsStyle="primary" onClick={::this.openHistory}>Voir l'historique</Button>
				{this.renderHistoryModal()}
			</div>
		);
	}
}

HistoryFlightComponent.contextTypes = {
	router: React.PropTypes.object.isRequired
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/flights/component-history-flight.js
 **/